import SearchBlock from './search_block'
import AllOrder from './all_order'
import SignCars from './sign_cars'
import RouterOrder from './router_order'
import RouteOrderGas from './route_order_gas'

export default {
  modules: {
    SearchBlock,
    AllOrder,
    SignCars,
    RouterOrder,
    RouteOrderGas
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/adjust_order/index.js